import { render, staticRenderFns } from "./Etapas1.vue?vue&type=template&id=0d2c509a&scoped=true&"
import script from "./etapas1.ts?vue&type=script&lang=ts&"
export * from "./etapas1.ts?vue&type=script&lang=ts&"
import style0 from "./Etapas1.vue?vue&type=style&index=0&id=0d2c509a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c509a",
  null
  
)

export default component.exports